import { SourceEnum } from '../enums/source.enum';
import { IRequiredValidators } from '../interfaces/required-validators.interface';

export class SourceConfig {
  static getRequiredValidators(source: string | null): IRequiredValidators {
    switch (source) {
      case SourceEnum.B2G_CONTABILIDADE:
        return {
          billing: false,
          openingDate: false,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.NIKOLAY:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.LCC:
        return {
          billing: false,
          openingDate: false,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.ACOMA:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.B2B:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.VML:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.FORTTIUS:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.ARAUJO_SOARES:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case SourceEnum.APOIO_EMPRESAS:
      case SourceEnum.AVANCECRED:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      case null:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
      default:
        return {
          billing: true,
          openingDate: true,
          sellToPj: true,
          sentInvoice: true,
        };
    }
  }
}
